module.exports = __webpack_public_path__ + "static/media/probe.7be69fb1.gif";